export const TID = {
  // Navigation
  navLogo: "nav-logo",
  navServices: "nav-link-services",
  navAbout: "nav-link-about",
  navProjects: "nav-link-projects",
  navContact: "nav-link-contact",
  navQuoteCta: "nav-quote-cta",
  langToggle: "lang-toggle",
  langEn: "lang-en",
  langEs: "lang-es",
  mobileMenuToggle: "mobile-menu-toggle",

  // Hero
  heroTitle: "hero-title",
  heroCtaPrimary: "hero-cta-primary",
  heroCtaSecondary: "hero-cta-secondary",

  // Services
  servicesSection: "services-section",
  serviceCard: (key) => `service-card-${key}`,

  // About
  aboutSection: "about-section",
  aboutCta: "about-cta",

  // Projects
  projectsSection: "projects-section",
  projectImage: (i) => `project-image-${i}`,

  // Service Area
  serviceAreaSection: "service-area-section",
  serviceAreaMap: "service-area-map",

  // Testimonials
  testimonialsSection: "testimonials-section",
  testimonialCard: (i) => `testimonial-card-${i}`,

  // Contact
  contactSection: "contact-section",
  contactForm: "contact-form",
  inputName: "contact-input-name",
  inputEmail: "contact-input-email",
  inputPhone: "contact-input-phone",
  selectService: "contact-select-service",
  selectServiceTrigger: "contact-select-service-trigger",
  inputMessage: "contact-input-message",
  submitBtn: "contact-submit",
  contactPhone: "contact-phone",
  contactEmail: "contact-email",
  successAlert: "contact-success",
  errorAlert: "contact-error",

  // Admin
  adminTable: "admin-table",
  adminEmpty: "admin-empty",
  adminRow: (id) => `admin-row-${id}`,
  adminMarkContacted: (id) => `admin-mark-contacted-${id}`,
  adminMarkClosed: (id) => `admin-mark-closed-${id}`,
  adminDelete: (id) => `admin-delete-${id}`,

  // Footer
  footer: "site-footer",
};
